const { gsap } = require('gsap');
import { ScrollTrigger } from "gsap/ScrollTrigger";

const windowScrollPage = function () {

	//-> header small header
	const scrollHeader = () => {
		ScrollTrigger.create({
			trigger: '#webdoor',
			start: 'bottom center',
			end: 99999,
			toggleClass: { className: 'scrolling', targets: '#header, #webdoor' },
			// markers : true
		});
	}

	const scrollFale = () => {
		ScrollTrigger.create({
			trigger: '#webdoor',
			start: '10% top',
			end: 99999,
			toggleClass: { className: 'scrolling', targets: '#fale-bt-link' },
			// markers : true
		});
	}

	const expImage = (() => {
        gsap.utils.toArray(".revealUp").forEach(el => {
            gsap.fromTo(el,
                {
                    scale: 1.4,
                    yPercent: -35
                }, {
                yPercent: 0,
                scale: 1,
                autoAlpha: 1,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    start: "top 50%",
                    end: "bottom bottom",
                    scrub: 2
                }
            });
        })

    })

	const animateLetters = (classTitle) => {
		const title = document.querySelector(classTitle);
		const chars = title.innerHTML.split("");
		title.innerHTML = "";
		chars.forEach((char, i) => {
			const charSpan = document.createElement("span");
			charSpan.innerHTML = char;
			title.appendChild(charSpan);
		});
		//Seperate text with spans - END

		const titleSpans = document.querySelectorAll(classTitle +" span");
		// titleSpans.forEach((span, index) => {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $(classTitle),
				start: "top 80%",
				end : "+=30%",
				toggleActions: "play none none none",
				markers: true,
				scrub: true
			}
		});
		tl.from(titleSpans, {
			// y: 100,
			duration: 2,
			color : 'transparent',
			ease: "power4.out",
			// delay: index * 1
			stagger: 0.4,
		});
	}

	//-> parallax webdoor
	const parallaxWebdoor = function (el) {

		gsap.fromTo($(el).not(".no-plx").find('picture'),
			{
				yPercent: 0,
				scale: 1,
			}, {
			yPercent: 35,
			scale: 1.6,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top top",
				end: "bottom -=50%",
				scrub: true,

			}
		});

	}

	//-> bg transition scroll View
	const bgTransitionInView = (classBg) => {
		const bgChange = gsap.utils.toArray(classBg);
		bgChange.forEach((bgs) => {
			gsap.from(bgs, {
				scrollTrigger: {
					start: 'top 65%',
					end: 'bottom top',
					trigger: bgs,
					toggleClass: 'in-view'
				}
			});
		});
	}

	//-> fade-In Element in scroll View
	const showFade = (classFade) => {
		const bgChange = gsap.utils.toArray(classFade);
		bgChange.forEach((elmFade) => {
			gsap.from(elmFade, {
				scrollTrigger: {
					start: 'top 75%',
					end: '+=100%',
					trigger: elmFade,
					toggleClass: 'in-view',
					// markers : true
				}
			});
		});
	}

	const elmInView = () => {
		const bgChange = gsap.utils.toArray('.js-elm-in-view');
		bgChange.forEach((eInView) => {
			gsap.from(eInView, {
				scrollTrigger: {
					start: 'top 75%',
					end: '+=150%',
					trigger: eInView,
					toggleClass: 'motion-in',
					// markers : true
				}
			});
		});
	}
	
	// alimate list
	const gridScrollAnimate = (() => {

        if (window.innerWidth < 712) return;

		ScrollTrigger.batch(".bl-el-info", {
			onEnter: elements => {
			  gsap.from(elements, {
				autoAlpha: 0,
				y: 60,
				stagger: 0.15
			  });
			},
			once: false
		  });
    })

	const layerMaskAnimation = (() => {

        gsap.utils.toArray(".mask-layer-animation").forEach(el => {
            gsap.to(el, {
                //height: 0,
                ease: "power4.out",
                duration: 1,
                scrollTrigger: {
                    trigger: el,
                    start: $(window).width() < 768 ? 'top bottom' : 'top center',
                    end: $(window).width() < 768 ? 'top top' : 'bottom center',
                    scrub: 2,
                    toggleClass: 'motion-in'
                }
            });
        })

    });


	const elmToScroll = function (el) {
		var _this = el.attr('data-scrollto');

		if ($(window).width() < 1000) {
			$("#nav-header, #bt-menu-mobile").removeClass('motion-in');
		}
		scrollToElm(_this);


	}

	const scrollToElm = function (target) {
		var offSTop = document.getElementById('header').clientHeight;
		if (target == '#section-projetos') {
			if ($(window).width() > 1200) {
				offSTop = 0;
			}
		}

		gsap.to(window, {
			duration: 2,
			scrollTo: { y: $(target).offset().top - ($(window).width() > 1200 ? offSTop : offSTop) },//scrollTo end bracket
			delay: 0,
			ease: 'Power4.easeInOut'
		});
		// gsap.to(window, {
		//     duration: 1,
		//     scrollTo: document.querySelector(target).offsetTop , //- document.querySelector('header').clientHeight
		//     ease: 'Expo.easeOut',
		// }
		//);
	}

	const limitWhatsScroll = () => {

		gsap.to("#ico-whats", {
			y: - (document.getElementById("limitWhats").clientHeight),
			scrollTrigger: {
				trigger: "#limitWhats",
				start: "top bottom",
				end: "bottom bottom",
				scrub: true,
				invalidateOnRefresh: true,
				// markers : true
			}
		})
	}

	const showMoreText = (el) => {
		let _parent = el.closest('.text');
		_parent.toggleClass('actived');
		if (_parent.hasClass('actived')) {
			el.text('-');
		} else {
			el.text('+');
		}
	}

	const footerAnime = () => {
		
		gsap.from("#footer-person", {
			x: - (screen.width),
			scrollTrigger: {
				trigger: "#limitWhats",
				start: "top bottom",
				end: "bottom bottom",
				scrub: true,
				invalidateOnRefresh: true,
				// markers : true
			}
		})

	}

	return {
		init: () => {

			scrollHeader();
			scrollFale();
			footerAnime();

			//zoom nas imagens
			if($('.revealUp').length > 0)
				expImage();			

			if ($('.jsShowLetters').length > 0)
				animateLetters('.jsShowLetters');

			if ($(".webdoor").length > 0)
				parallaxWebdoor(".webdoor");

			if ($('.bg-transition').length > 0)
				bgTransitionInView('.bg-transition');

			if ($('.showFade').length > 0)
				showFade('.showFade');
			
			if ($('.js-elm-in-view').length > 0)
				elmInView();
			
			if ($('.bl-el-info').length > 0)
				gridScrollAnimate();

			$('.text-more').on('click', function () {
				showMoreText($(this));
			});

			if (document.querySelector('.mask-layer-animation')) {
                setTimeout(() => {
                    layerMaskAnimation();
                }, _timerSync);
            }


			$(document).on('click', '[data-scrollto]', function (e) {
				e.preventDefault();
				elmToScroll($(this));
			});

			setTimeout(() => {
				limitWhatsScroll();
			}, 3000);
			//marcar menu


			/* 			if($('.text-intro').length > 0)
							introText('.text-intro');
			 */


		}
	}

}();

export default windowScrollPage;